import { SideBarItemConfig } from '../baseSideBarItemConfig'
import { launchPadRouteNames } from '@/routes/constants/location'

const i18nConfigText = 'common.sidebar.launchpad'

const launchpadConfig: SideBarItemConfig = {
  name: i18nConfigText,
  enabled: true,
  items: [],
  type: 'header',
  meta: 'launchpad',
  tooltip: i18nConfigText,
  permissions: {
    all: [],
    any: [],
  },
  icon: 'https://cdn.msgsndr.com/sidebar-v2/icon_launchpad.svg',
  children: [],
  route: {
    name: launchPadRouteNames.default,
    params: ['location_id'],
  },
  userScopes: {
    any: [],
    all: ['launchpad/location.write'],
  },
}

export default launchpadConfig
